import React, { useState, useEffect } from "react";

import { AppContext } from "./AppContext";
const AppState = (props) => {
  const [isLogin, setIsLogin] = useState(false);



  let adminInitialData = {
    userId: "",
    auth_token: "",
    email: "",
    admin: "",
    isHaveJd: false
  };

  const [companyDtls, setCompnayDtls] = useState({
    company: "",
    designation: "",
    position: "",
  });

  const [adminData, setAdminData] = useState(adminInitialData);
  const [openSideBar, setOpenSideBar] = useState(true);
  const [activeMenu, setActiveMenu] = useState(sessionStorage.getItem('activeMenu') || "grouplist");
  // const [activeMenu, setActiveMenu] = useState("grouplist");

  useEffect(() => {
    console.log("USerID-->", localStorage.getItem("userId"));

    setAdminData((prev) => ({
      ...prev,
      userId: localStorage.getItem("userId")
        ? JSON.parse(localStorage.getItem("userId"))
        : null,
      auth_token: localStorage.getItem("auth_token")
        ? localStorage.getItem("auth_token")
        : null,
      admin: localStorage.getItem("admin")
        ? JSON.parse(localStorage.getItem("admin"))
        : null,
      email: localStorage.getItem("email")
        ? JSON.parse(localStorage.getItem("email"))
        : null,
      isHaveJd: localStorage?.getItem('isHaveJd') ? JSON?.parse(localStorage?.getItem('isHaveJd')) : false
    }));

    setIsLogin(localStorage.getItem("userId") ? true : false);
  }, []);


  const handleLogout = () => {
    setIsLogin(false);
    setAdminData(adminInitialData);
    localStorage.clear();

  }

  return (
    <div>
      <AppContext.Provider
        value={{
          isLogin,
          setIsLogin,
          adminData,
          setAdminData,
          adminInitialData,
          openSideBar,
          setOpenSideBar,
          activeMenu,
          setActiveMenu,
          companyDtls,
          setCompnayDtls,
          handleLogout
        }}
      >
        {props.children}
      </AppContext.Provider>
    </div>
  );
};

export default AppState;
